import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { FLAG_OWNER_CHANGE_EXTENSION } from './flag/components/FlagUpdatesSidebar/OwnerChangeExtension';
import { RULE_CHANGE_EXTENSION } from './flag/components/FlagUpdatesSidebar/RuleChangeExtension';
import { SCHEMA_CHANGE_EXTENSION } from './flag/components/FlagUpdatesSidebar/SchemaChangeExtension';
import { STRING_CHANGE_EXTENSION } from './flag/components/FlagUpdatesSidebar/StringChangeExtension';
import { VARIANT_CHANGE_EXTENSION } from './flag/components/FlagUpdatesSidebar/VariantChangeExtension';
import { ExternalRoutes, Routes, rootRouteRef } from './routes';
import {
  SEGMENT_CREATED_EXTENSION,
  SEGMENT_OWNER_CHANGE_EXTENSION,
  SEGMENT_STRING_CHANGE_EXTENSION,
  SEGMENT_TARGETING_ALLOCATION_CHANGE_EXTENSION,
} from './segment/components/SegmentUpdatesSidebar';

export const flagsPlugin = createPlugin({
  id: 'flags',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
  featureFlags: [],
});

export const bindFlagRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(flagsPlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...flagsPlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceFlagsPage = flagsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceFlagsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-flags", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const ConfidenceFlagsExtension = flagsPlugin.provide(
  createComponentExtension({
    name: 'ConfidenceFlagsExtension',
    component: {
      lazy: () =>
        import(
          /* webpackChunkName: "confidence-flags-extension", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
    },
  }),
);

// Flag change extensions
export const FlagOwnerChangeExtension = flagsPlugin.provide(
  FLAG_OWNER_CHANGE_EXTENSION,
);
export const FlagSchemaChangeExtension = flagsPlugin.provide(
  SCHEMA_CHANGE_EXTENSION,
);
export const FlagVariantChangeExtension = flagsPlugin.provide(
  VARIANT_CHANGE_EXTENSION,
);
export const FlagRuleChangeExtension = flagsPlugin.provide(
  RULE_CHANGE_EXTENSION,
);
export const FlagStringChangeExtension = flagsPlugin.provide(
  STRING_CHANGE_EXTENSION,
);

// Segment change extensions
export const SegmentOwnerChangeExtension = flagsPlugin.provide(
  SEGMENT_OWNER_CHANGE_EXTENSION,
);
export const SegmentTargetingAllocationChangeExtension = flagsPlugin.provide(
  SEGMENT_TARGETING_ALLOCATION_CHANGE_EXTENSION,
);
export const SegmentStringChangeExtension = flagsPlugin.provide(
  SEGMENT_STRING_CHANGE_EXTENSION,
);
export const SegmentCreatedExtension = flagsPlugin.provide(
  SEGMENT_CREATED_EXTENSION,
);
